<div class="card card-inline-help_card">
  <div class="card-body text-center card-inline-help_card--body">
    <div class="mb-5">
      <img src="{{cardDetails?.cardImagePath}}" alt="{{cardDetails?.cardAlt}}" width="{{cardDetails?.cardWidth}}">
    </div>
    <h5 class="card-title mb-5">{{cardDetails?.cardTitle}}</h5>
    <a routerLink="{{cardDetails?.cardLinkUrl}}" class="card-inline-help_card--link">{{cardDetails?.cardSubTitle}}</a>
  </div>
</div>